// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import {
  Register,
  Sso,
  LogOut,
} from './';

import AuthModal from './AuthModal';
import { by } from '../../common/routerAccess';

export default {
  path: 'auth',
  name: 'Authentification',
  access: by.only.VISITOR,
  childRoutes: [
    { path: 'signin', name: 'Log in', component: AuthModal },
    //{ path: 'signup', name: 'Register', component: Register },
    { path: 'sso', name: 'Sso', component: Sso },
    { path: 'signout', name: 'Log out', component: LogOut, access: [by.only.USER, by.only.ADMIN] },
  ],
};



// WEBPACK FOOTER //
// ./src/features/authentification/route.js